import axiosInstance from "../axiosApi/api";
import { handleServerError } from "./errors";
import {
  DELETE_MY_QR,
  GET_INFO_FOR_FIND_PET,
  GET_MY_QRS,
  GET_OVERALL_STATISTICS,
  CLAIM_QR_CODE,
  CLAIM_QR_CODE_SUCCESS,
  CLAIM_QR_CODE_ERROR,
  UPDATE_CLAIMED_QR,
  CLEAR_CLAIM_STATE,
  OWNER_LOGIN,
  OWNER_LOGIN_SUCCESS,
  OWNER_LOGIN_ERROR,
  OWNER_UPDATE_QR,
  OWNER_TOGGLE_LOST,
  OWNER_LOGOUT,
  SEND_OTP,
  SEND_OTP_SUCCESS,
  SEND_OTP_ERROR,
  VERIFY_OTP,
  VERIFY_OTP_SUCCESS,
  VERIFY_OTP_ERROR,
  CLEAR_OTP_STATE,
} from "./types";
import { withNotification } from "../utils/withNotification.js";

export const getTransactionUrl = (formData, order_type) => {
  return async (dispatch) => {
    try {
      // Build FormData for multipart upload (local storage)
      const submitData = new FormData();

      // Handle pet_image if present
      if (formData.pet_image && formData.pet_image[0]) {
        submitData.append("pet_image", formData.pet_image[0]);
      }

      // Handle custom_design_img if present
      if (formData.custom_design_img && formData.custom_design_img[0]) {
        submitData.append("custom_design_img", formData.custom_design_img[0]);
      }

      // Process customDesigns array - extract files for separate upload
      if (formData.customDesigns && formData.customDesigns.length > 0) {
        const cleanedDesigns = formData.customDesigns.map((design, index) => {
          if (design.image) {
            // Handle base64 data URL strings (from localStorage persistence)
            if (typeof design.image === 'string' && design.image.startsWith('data:')) {
              const [header, data] = design.image.split(',');
              const mime = header.match(/:(.*?);/)[1];
              const ext = mime.split('/')[1] || 'png';
              const binary = atob(data);
              const arr = new Uint8Array(binary.length);
              for (let i = 0; i < binary.length; i++) arr[i] = binary.charCodeAt(i);
              const file = new File([arr], `custom_design_${index}.${ext}`, { type: mime });
              submitData.append(`custom_design_${index}`, file);
            } else if (typeof design.image === 'object') {
              // Handle raw File objects (legacy)
              submitData.append(`custom_design_${index}`, design.image);
            }
            return {
              id: design.id,
              quantity: design.quantity,
            };
          }
          return design;
        });
        submitData.append("customDesigns", JSON.stringify(cleanedDesigns));
      }

      // Add all other form fields to FormData
      const fieldsToInclude = [
        'color', 'size', 'full_name', 'gender', 'pet_color', 'pet_type',
        'pet_breed', 'phone_number', 'quantity', 'price', 'user', 'for_friend',
        'city', 'address', 'pet_name', 'is_vaccinated', 'comment',
        'second_phone_number', 'colorQuantities', 'color_quantities'
      ];

      fieldsToInclude.forEach(field => {
        if (formData[field] !== undefined && formData[field] !== null) {
          if (typeof formData[field] === 'object' && !(formData[field] instanceof File)) {
            submitData.append(field, JSON.stringify(formData[field]));
          } else {
            submitData.append(field, formData[field]);
          }
        }
      });

      const currentLang = localStorage.getItem("i18nextLng").toUpperCase();
      const res = await withNotification({
        promise: axiosInstance.post(
          `/orders/transaction/url/${currentLang}/${order_type}/`,
          submitData,
          {
            timeout: 30000,
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        ),
      });

      // Redirect to payment or success page
      window.open(res.data.transaction_url, "_self");
    } catch (e) {
      handleServerError(dispatch, e);
    }
  };
};

export const getMyQrsAction = () => {
  return async (dispatch) => {
    try {
      // Use new pool-based endpoint that returns QR codes with uuid
      const res = await axiosInstance.get("/orders/my/qrcodes/");
      dispatch({
        type: GET_MY_QRS,
        payload: res.data,
      });
    } catch (e) {
      handleServerError(dispatch, e);
    }
  };
};

export const toggleHiddenCollar = (qrIdentifier) => {
  return async (dispatch) => {
    try {
      await withNotification({
        promise: axiosInstance.post(
          `/orders/my/qrcodes/${qrIdentifier}/toggle-hidden/`
        ),
      });
      // Reload the list so the dashboard reflects the new visibility state
      const res = await axiosInstance.get("/orders/my/qrcodes/");
      dispatch({
        type: GET_MY_QRS,
        payload: res.data,
      });
    } catch (e) {
      handleServerError(dispatch, e);
    }
  };
};

export const deleteQR = (qrID) => {
  return async (dispatch) => {
    try {
      await withNotification({
        promise: axiosInstance.delete(`/orders/my/qrs/${qrID}/`),
      });
      dispatch({
        type: DELETE_MY_QR,
        payload: qrID,
      });
    } catch (e) {
      handleServerError(dispatch, e);
    }
  };
};

export const updateQR = (qrID, formData) => {
  return async (dispatch) => {
    try {
      // Build FormData for multipart upload (local storage)
      const submitData = new FormData();

      // Handle pet_image if it's a file (not a string URL)
      if (formData.pet_image && typeof formData.pet_image !== "string") {
        submitData.append("pet_image", formData.pet_image[0]);
      }

      // Add other fields
      const fields = ['city', 'address', 'comment', 'phone_number', 'second_phone_number'];
      fields.forEach(field => {
        if (formData[field] !== undefined && formData[field] !== null) {
          submitData.append(field, formData[field]);
        }
      });

      await withNotification({
        promise: axiosInstance.put(`/orders/my/qrs/${qrID}/`, submitData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }),
      });
    } catch (e) {
      handleServerError(dispatch, e);
    }
  };
};

export const changeQRMarkedAsLost = (qrID) => {
  return async (dispatch) => {
    try {
      await withNotification({
        promise: axiosInstance.post(`/orders/my/qrs/${qrID}/`),
      });
    } catch (e) {
      handleServerError(dispatch, e);
    }
  };
};

export const getFindPetInfo = (qrID) => {
  return async (dispatch) => {
    try {
      const res = await axiosInstance.get(`/orders/qr/${qrID}/`);
      dispatch({
        type: GET_INFO_FOR_FIND_PET,
        payload: res.data,
      });
    } catch (e) {
      handleServerError(dispatch, e);
    }
  };
};

export const sendLocation = (qrID, data) => {
  return async (dispatch) => {
    try {
      await withNotification({
        promise: axiosInstance.post(`/orders/qr/${qrID}/`, data),
        successMessage: "Your location was sent successfully",
      });
    } catch (e) {
      handleServerError(dispatch, e);
    }
  };
};

export const getOverallStatisticsAction = () => {
  return async (dispatch) => {
    try {
      const res = await axiosInstance.get(`/orders/static/`);
      dispatch({
        type: GET_OVERALL_STATISTICS,
        payload: res.data,
      });
    } catch (e) {
      handleServerError(dispatch, e);
    }
  };
};

// ===== QR Code Claim Actions (for retail store purchases) =====

export const claimQRCode = (qrUUID, phoneNumber) => {
  return async (dispatch) => {
    dispatch({ type: CLAIM_QR_CODE });
    try {
      const res = await withNotification({
        promise: axiosInstance.post(`/orders/qr/${qrUUID}/claim/`, {
          phone_number: phoneNumber,
        }),
        successMessage: "QR code claimed successfully!",
      });

      // Store tokens if returned
      if (res.data.access) {
        localStorage.setItem("access_token", res.data.access);
        localStorage.setItem("refresh_token", res.data.refresh);
      }

      dispatch({
        type: CLAIM_QR_CODE_SUCCESS,
        payload: res.data,
      });

      return res.data;
    } catch (e) {
      dispatch({
        type: CLAIM_QR_CODE_ERROR,
        payload: e.response?.data || { error: "Failed to claim QR code" },
      });
      handleServerError(dispatch, e);
      throw e;
    }
  };
};

export const updateClaimedQR = (qrUUID, petData) => {
  return async (dispatch) => {
    try {
      // Build FormData for multipart upload (local storage)
      const submitData = new FormData();

      // Handle pet image if it's a file
      if (petData.pet_image && typeof petData.pet_image !== "string") {
        submitData.append("pet_image", petData.pet_image[0]);
      }

      // Add other fields
      const fields = [
        'pet_name', 'pet_type', 'pet_breed', 'gender', 'pet_color',
        'is_vaccinated', 'full_name', 'phone_number', 'second_phone_number',
        'city', 'address', 'comment'
      ];

      fields.forEach(field => {
        if (petData[field] !== undefined && petData[field] !== null) {
          submitData.append(field, petData[field]);
        }
      });

      const res = await withNotification({
        promise: axiosInstance.put(`/orders/qr/${qrUUID}/update/`, submitData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }),
        successMessage: "Pet info saved successfully!",
      });

      dispatch({
        type: UPDATE_CLAIMED_QR,
        payload: res.data,
      });

      return res.data;
    } catch (e) {
      handleServerError(dispatch, e);
      throw e;
    }
  };
};

export const clearClaimState = () => {
  return { type: CLEAR_CLAIM_STATE };
};

// ===== Owner Login Actions (for existing QR collars) =====

export const ownerLogin = (qrID, phoneNumber) => {
  return async (dispatch) => {
    dispatch({ type: OWNER_LOGIN });
    try {
      const res = await withNotification({
        promise: axiosInstance.post(`/orders/qr/${qrID}/owner-login/`, {
          phone_number: phoneNumber,
        }),
        successMessage: "Login successful!",
      });

      // Store tokens and update axios defaults
      if (res.data.access) {
        localStorage.setItem("access_token", res.data.access);
        localStorage.setItem("refresh_token", res.data.refresh);
        // Update axios instance headers for subsequent requests
        axiosInstance.defaults.headers["Authorization"] = "Bearer " + res.data.access;
      }

      dispatch({
        type: OWNER_LOGIN_SUCCESS,
        payload: res.data,
      });

      return res.data;
    } catch (e) {
      dispatch({
        type: OWNER_LOGIN_ERROR,
        payload: e.response?.data || { error: "Invalid phone number" },
      });
      throw e;
    }
  };
};

// ===== OTP Verification Actions =====

export const sendOTP = (qrID, phoneNumber) => {
  return async (dispatch) => {
    dispatch({ type: SEND_OTP });
    try {
      const res = await axiosInstance.post(`/orders/qr/${qrID}/send-otp/`, {
        phone_number: phoneNumber,
      });

      dispatch({
        type: SEND_OTP_SUCCESS,
        payload: {
          ...res.data,
          phoneNumber: phoneNumber,
        },
      });

      return res.data;
    } catch (e) {
      const errorData = e.response?.data || { error: "Failed to send verification code" };
      dispatch({
        type: SEND_OTP_ERROR,
        payload: errorData,
      });
      throw e;
    }
  };
};

export const verifyOTP = (qrID, phoneNumber, code) => {
  return async (dispatch) => {
    dispatch({ type: VERIFY_OTP });
    try {
      const res = await withNotification({
        promise: axiosInstance.post(`/orders/qr/${qrID}/verify-otp/`, {
          phone_number: phoneNumber,
          code: code,
        }),
        successMessage: "Verification successful!",
      });

      // Store tokens and update axios defaults
      if (res.data.access) {
        localStorage.setItem("access_token", res.data.access);
        localStorage.setItem("refresh_token", res.data.refresh);
        axiosInstance.defaults.headers["Authorization"] = "Bearer " + res.data.access;
      }

      dispatch({
        type: VERIFY_OTP_SUCCESS,
        payload: res.data,
      });

      // Also dispatch OWNER_LOGIN_SUCCESS to set isLoggedIn state
      dispatch({
        type: OWNER_LOGIN_SUCCESS,
        payload: res.data,
      });

      return res.data;
    } catch (e) {
      const errorData = e.response?.data || { error: "Invalid verification code" };
      dispatch({
        type: VERIFY_OTP_ERROR,
        payload: errorData,
      });
      throw e;
    }
  };
};

export const clearOTPState = () => {
  return { type: CLEAR_OTP_STATE };
};

export const ownerUpdateQR = (qrID, formData) => {
  return async (dispatch) => {
    try {
      // Create FormData for multipart upload (local storage)
      const submitData = new FormData();

      // Handle pet image if it's a file
      if (formData.pet_image && typeof formData.pet_image !== "string") {
        const pet_image = formData.pet_image[0];
        submitData.append("pet_image", pet_image);
      }

      // Add other fields to FormData
      const fields = ['pet_name', 'pet_type', 'pet_breed', 'gender', 'pet_color',
                      'is_vaccinated', 'full_name', 'phone_number', 'second_phone_number',
                      'city', 'address', 'comment'];

      fields.forEach(field => {
        if (formData[field] !== undefined && formData[field] !== null) {
          submitData.append(field, formData[field]);
        }
      });

      const res = await withNotification({
        promise: axiosInstance.put(`/orders/qr/${qrID}/owner-update/`, submitData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }),
        successMessage: "Pet info updated successfully!",
      });

      dispatch({
        type: OWNER_UPDATE_QR,
        payload: res.data,
      });

      return res.data;
    } catch (e) {
      handleServerError(dispatch, e);
      throw e;
    }
  };
};

export const ownerToggleLost = (qrID) => {
  return async (dispatch) => {
    try {
      const res = await withNotification({
        promise: axiosInstance.post(`/orders/qr/${qrID}/owner-update/`),
        successMessage: "Status updated successfully!",
      });

      dispatch({
        type: OWNER_TOGGLE_LOST,
        payload: res.data,
      });

      return res.data;
    } catch (e) {
      handleServerError(dispatch, e);
      throw e;
    }
  };
};

export const ownerLogout = () => {
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  return { type: OWNER_LOGOUT };
};
